const PROGRAM_TOOLS_LIST = 'bfb/program/PROGRAM_TOOLS_LIST';
const PROGRAM_TOOLS_LIST_SUCCEEDED = 'bfb/program/PROGRAM_TOOLS_LIST_SUCCEEDED';
const PROGRAM_TOOLS_LIST_FAILED = 'bfb/program/PROGRAM_TOOLS_LIST_FAILED';

export default {
  PROGRAM_TOOLS_LIST,
  PROGRAM_TOOLS_LIST_SUCCEEDED,
  PROGRAM_TOOLS_LIST_FAILED,
};
